// Elements
const elements = {
	mainImages: document.querySelectorAll('.prd-Product_GridItem.prd-Product_GridItem-image'),
	closeBar: document.querySelector('.close-bar'),
}

const init = () => {
	// Initialize the top gallery swiper
	const galleryTop = new Swiper('.gallery-top', {
		slidesPerView: 1,
		loop: false,
		mousewheelControl: true,
		freeMode: true,
		freeModeSticky: true,
		direction: 'vertical',
		spaceBetween: 30,
	})
	// Initialize the thumbnail gallery swiper
	const galleryThumbs = new Swiper('.gallery-thumbs', {
		direction: 'vertical',
		slideToClickedSlide: true,
		spaceBetween: 10,
		loopedSlides: 50,
		direction: 'vertical',
	})
	// Link the top and thumbnail gallery swipers
	galleryTop.controller.control = galleryThumbs
	galleryThumbs.controller.control = galleryTop

	// Add click event listener to the close button
	elements.closeBar.addEventListener('click', () => {
		document.getElementById('overlay').style.display = 'none'
		document.querySelector('html').style.overflowY = 'visible'
	})
	// Add click event listener to each main product images
	elements.mainImages.forEach(image => {
		image.addEventListener('click', () => {
			document.getElementById('overlay').style.display = 'block'
			galleryTop.slideTo(image.getAttribute('data-img-position'))
			document.querySelector('html').style.overflowY = 'hidden'
		})
	})
}

document.addEventListener('DOMContentLoaded', init)
